<div class="item-bag" [ngClass]="{ 'item-bag-classic': enableClassic, 'item-bag': !enableClassic }">
  <div class="bag-title">
    <p class="fs-16px lh-22px fw-medium-x" *ngIf="!enableClassic">{{ title | translate }}</p>
    <p class="fs-16px lh-22px fw-medium-x" *ngIf="enableClassic && !statusBag">
      {{ passengerCarryOn.displayName }}
    </p>
    <p class="fs-16px lh-22px fw-medium-x" *ngIf="enableClassic && statusBag == StatusBag.TO_PAY">
      {{ 'bagsSelection.carryOnaddLabel' | translate }}
    </p>
    <p class="bag-subtitle fs-14px lh-18px fw-regular">
      <img src="./assets/images/bags/bag-sinCosto.svg" *ngIf="hasbagToBenefit" />
      <span
        *ngIf="
          (!enableClassic || hasbagToBenefit) &&
          !(passengerCarryOn.isNextBagUnavailable && (hasBags25Kg || hasBags20Kg || hasBags32Kg))
        "
        >{{ subtitle | translate }}</span
      >
      <!-- <span *ngIf="enableClassic && statusBag == StatusBag.TO_PAY">{{ subtitleClassic }}</span> -->
      <span
        *ngIf="
          enableClassic && !statusBag && !hasbagToBenefit && !passengerCarryOn.isNextBagUnavailable
        "
        >{{ subtitleCostClassic }} {{ cost | amCurrency }}</span
      >
      <!-- Mostrar "No disponible" solo en columna de equipaje documentado -->
      <span
        *ngIf="
          passengerCarryOn.isNextBagUnavailable &&
          !hasbagToBenefit &&
          (hasBags25Kg || hasBags20Kg || hasBags32Kg)
        "
        class="text-am-warning"
        >{{ 'bagsSelection.bag-status.unavailable' | translate }}</span
      >
    </p>
  </div>
  <div
    class="bag-actions"
    [ngClass]="{ 'bag-actions-classic': enableClassic, 'bag-actions': !enableClassic }"
  >
    <div class="bag-include" *ngIf="hasBagToInclude && !enableClassic">
      <img src="./assets/images/bags/bag-check_circle.svg" />
      <span class="fs-16px lh-22px fw-medium-x">1</span>
      <span class="fs-16px lh-22px fw-medium-x">{{
        'bagSelectionCarryonBasic.itemBag.include' | translate
      }}</span>
    </div>
    <!-- <div class="bag-include" *ngIf="enableClassic && statusBag == StatusBag.TO_PAY">

      <app-am-check-box [check]="statusBag == StatusBag.TO_PAY ? true: false" (handleCheck)="onHandleCheck($event)"></app-am-check-box>

    </div> -->
    <div class="bag-include" *ngIf="enableCheck">
      <am-bag-add-carryon
        [passengerCarryOn]="passengerCarryOn"
        [passengersCarryOn]="passengersCarryOn"
        [statusBag]="statusBag"
        [enableCheck]="enableCheck"
        [fareFamily]="fareFamily"
        [connectionBlocked]="isConnectionBlocked"
        (onChangeExtraWeight)="handleChangeExtraWeightBags($event, passengerCarryOn)"
        (onConnectionBlocked)="onPlusBlocked()"
      >
      </am-bag-add-carryon>
    </div>
    <!-- Texto informativo para BASIC/MAIN_LIGHT cuando la maleta está PAID o INCLUDE -->
    <div class="carry-on-weight-info" *ngIf="showCarryOnWeightInfo">
      <p class="weight-text">
        Tu equipaje de mano cuenta con<br />
        el peso máximo de <span class="carryon-weight-value">15kg</span>
      </p>
    </div>
    <!-- Counter para main_light carry-on -->
    <div
      class="bag-buttons"
      *ngIf="showCounterForMainLightWithoutPaid && !has5kg && !hasbagToBenefit"
    >
      <am-counter
        (handleCount)="handleCountBags($event)"
        (minus)="onMinusCarryOnMainLight()"
        (plus)="onPlusCarryOnMainLight()"
        [count]="onCount()"
        [enablePlus]="onCount() < 1"
        [blockPlus]="isConnectionBlocked"
        (onBlockedPlus)="onPlusBlocked()"
        [newdata]="true"
        [maxCount]="maxCarryOnPerPassenger"
      >
      </am-counter>
    </div>
    <div class="carryon-benefit-switch" *ngIf="hasCarryonRedeemAvailable && !enableCheck">
      <am-input-switch
        label="bagSelectionCarryonBasic.inbursaCarryon.switchLabel"
        [size]="'md'"
        [isAllowedToRedeem]="true"
        [(ngModel)]="carryonBenefitSwitch"
        (change)="onToggleCarryonBenefit($event)"
      ></am-input-switch>
    </div>
    <!--
      CI-19584 — (abarca las 2 columnas) en bag-selection-carryon-basic.
    -->
    <div class="carryon-benefit-applied" *ngIf="hasCarryonApplied && !enableCheck">
      <div class="bag-include">
        <img src="./assets/images/bags/bag-check_circle.svg" alt="" />
        <span class="fs-16px lh-22px fw-medium-x">1</span>
        <span class="fs-16px lh-22px fw-medium-x">{{
          'bagSelectionCarryonBasic.inbursaCarryon.redeemedBadge' | translate
        }}</span>
      </div>
    </div>
    <!-- Counter para otros casos (equipaje documentado) -->
    <div
      class="bag-buttons"
      *ngIf="
        ((enableClassic && typeBagsWeight !== BagsWeight._10KG) ||
          (!hasBagToInclude && typeBagsWeight !== BagsWeight._10KG)) &&
        !has5kg &&
        !showCounterForMainLight
      "
    >
      <am-counter
        (handleCount)="handleCountBags($event)"
        (minus)="onMinusBagConnection($event)"
        (plus)="onPlusBag($event, extraBags, isDomestic)"
        [blockPlus]="isConnectionBlocked"
        (onBlockedPlus)="onBlockedPlusBag($event)"
        [syncTrigger]="syncCounter"
        [count]="onCount()"
        [enablePlus]="
          passengerCarryOn.availableBagsAdd(BagsWeight._25KG, isDomestic) &&
          !passengerCarryOn.isNextBagUnavailable
        "
        [enableMinus]="removableBagsCount > 0"
        [newdata]="true"
      >
      </am-counter>
      <!-- <button class="bag-button" [disabled]="count==0" [ngClass]="{'disabled' :count ==0 , 'active' :count >0}" (click)="passengerOld.onMinusBag($event, BagsWeight._32KG)">-</button>
      <div class="bag-count"> <span>{{count}}</span></div>
      <button class="bag-button" (click)="onPlus()" [disabled]="!enablePlus">+</button> -->
    </div>
  </div>
</div>
<!--

(handleCount)="handleCountBags($event)"
              (minus)="item.onMinusBag($event, BagsWeight._32KG)"
              (plus)="item.onPlus32kg($event)"
              [count]="item.bags32Kg"
              [enablePlus]="item.availableBagsAdd(BagsWeight._32KG)" -->
